import { chakra, type HTMLChakraProps } from '@chakra-ui/react';

import { WILSON_PALETTE } from './wilson-brand';

/**
 * Wilson Analytics full text logo.
 *
 * Default `viewBox="0 0 85 13"` shows the entire "Wilson Analytics" mark.
 * Callers that want only the "W" + dot (e.g. the account portal login page)
 * pass `viewBox="34 0 51 13"` to crop the leading whitespace.
 */
const WilsonFullLogo = (props: HTMLChakraProps<'svg'>) => (
  <chakra.svg
    width="280"
    height="43"
    viewBox="0 0 85 13"
    fill="none"
    {...props}
  >
    <path
      d="M51.8,0c1.3,0,2.1.7,2.1,1.8s-.8,1.8-2.1,1.8-2.1-.7-2.1-1.8.8-1.8,2.1-1.8Z"
      fill={WILSON_PALETTE.accent}
    />
    <polygon
      points="53.7 4 53.7 12.8 49.9 12.8 49.9 4.8 47.3 12.8 43.6 12.8 42.4 8.5 41.2 12.8 37.5 12.8 34.7 4 38.6 4 39.7 8.6 40.8 4 44 4 45.1 8.6 46.2 4 53.7 4"
      fill={WILSON_PALETTE.darkNeutral}
    />
    <path
      d="M81.7,3.8c-1.3,0-2,.6-2.5,1.3v-1.1c0,0-3.8,0-3.8,0v3c-.6-2-2.5-3.1-4.9-3.1s-5.1,1.7-5.1,4.6,0,.1,0,.2c-.5-.8-1.4-1.3-2.5-1.6h-.4c-.5-.2-.9-.4-.9-.6s.1-.2.5-.2c.6,0,1.6.3,2.4.8l1.1-2.2c-.4-.3-1.5-1-3.6-1s-3.7,1.1-3.7,2.9,1.2,2.3,2,2.5l1,.3c.7.2,1.1.3,1.1.6s-.3.2-.4.2c-.3,0-1.7-.1-2.8-.8l-1.1,1.9V.9h-3.9v11.9h3.9v-.8c1.1.8,2.5,1,3.8,1,2.1,0,3.7-1,3.9-2.7.7,1.8,2.5,2.7,4.7,2.7s4.3-1.1,4.9-3.1v2.9s3.9,0,3.9,0v-4.3c0-.9,0-1.5.9-1.5.8,0,.9.7.9,1.5v4.3s3.9,0,3.9,0v-5.2c0-2.2-.7-3.8-3.3-3.8h0ZM70.6,9.9c-.8,0-1.2-.6-1.2-1.5s.4-1.5,1.2-1.5,1.2.6,1.2,1.5-.4,1.5-1.2,1.5Z"
      fill={WILSON_PALETTE.darkNeutral}
    />
  </chakra.svg>
);

export default WilsonFullLogo;
